/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=24f40c75&scoped=true&"
import script from "./Setting.vue?vue&type=script&setup=true&lang=js&"
export * from "./Setting.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Setting.vue?vue&type=style&index=0&id=24f40c75&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f40c75",
  null
  
)

export default component.exports